import { tns } from "tiny-slider";

const sliders = Array.from(document.querySelectorAll(".item-list-wrapper--slider"));

function manageNav(nav, responsive) {

    const navChildren = Array.from(nav.children)
    let count = navChildren.length

    for (const [size, value] of Object.entries(responsive)) {
        if (window.innerWidth > size) {
            count = (Math.ceil(navChildren.length / value.items))
        }
    }

    navChildren.map((child, i) => {
        if (i+1 > count) {
            child.style.display = 'none'
        } else {
            child.style.display = 'block'
        }
    })
}

function check(el, slider = null) {

    const container = el.querySelector('.item-list')
    const navContainer = el.querySelector('.item-list--slider-nav')
    const controlsContainer = el.querySelector('.item-list-links-controls')

    let force = false;

    if(el.dataset.productSlider) {
        force = true;
    }

    let responsive = {
        480: {
            items: 2,
        },
    }

    if(force) {
        responsive = {
            480: {
                items: 2,
            },
            640: {
                items: 3,
            },
            768: {
                items: 3,
            },
            1024: {
                items: 4,
            },
        }
    }

    if (force || window.innerWidth < 1024) {

        if (slider === null) {

            let sliderOptions = {
                container,
                controls: false,
                navContainer,
                items: 1,
                gutter: 50,
                responsive
            };

            if (controlsContainer) {
                sliderOptions = {
                    container,
                    controlsContainer,
                    nav: false,
                    items: 1,
                    gutter: 50,
                    responsive
                };
            }

            slider = tns(sliderOptions)
        } else {
            if (slider.getInfo === null) {
                slider = null
            }
        }

        if(navContainer) {
            manageNav(navContainer, responsive)
        }

        el.classList.add('active-slider')

    } else {

        if (slider !== null) {

            if (slider.destroy) {
                slider.destroy()
            }

            el.classList.remove('active-slider')
        }

    }

    return slider;
}

function setup(el) {

    let slider = check(el)

    window.addEventListener('resize', () => {
        slider = check(el, slider)
    })
}

function init() {
    if (!sliders) return;

    sliders.forEach(setup)

}

init();
